import { BpostBarcodeClient } from '@frontend/bpost/api';
import { OpenModalFunction } from '@frontend/modal';
import { ToastUtil } from '@frontend/toast-utils';

import { PreviewPDF } from '../../applications/laundry/labels/preview-pdf/preview-pdf.component';

export const LAUNDRY_SHIPPING_LABEL_MODAL_KEY = 'laundry-shipping-label-modal';

export async function previewLaundryShippingLabel(trackingNumber: string, openModal: OpenModalFunction): Promise<void> {
    const barcode = await BpostBarcodeClient.fetchBarcodes({ code: trackingNumber });
    if (barcode.count === 0) {
        ToastUtil.error('No barcode found for this tracking number');
        return;
    }
    openModal(LAUNDRY_SHIPPING_LABEL_MODAL_KEY, () => <PreviewPDF barcode={barcode.results[0]} />);
}
